import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

import { selectIsWithoutMinimalBet } from './selectIsWithoutMinimalBet';
import { selectIsPromotionPackageSelected } from './selectIsPromotionPackageSelected';
import { selectActiveServiceId } from './selectActiveServiceId';

export const selectIsIncreaseToMinimalBet = (state: IAppState): boolean => {
  const isWithoutMinimalBet = selectIsWithoutMinimalBet(state);
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const activeServiceId = selectActiveServiceId(state);

  return isWithoutMinimalBet && !isPromotionPackageSelected && activeServiceId === EServiceId.top;
};
